import { apiService } from 'utils/api';

const baseUrl = process.env.REACT_APP_ORDER_STATS_API_KEY;
const brandMgtBaseUrl = process.env.REACT_APP_BRAND_MGT_API_URL;

export const InventoryService = {
  exportCSV: async (data: {
    brand_ids: string[];
    email: string;
  }): Promise<{ status: string; message: string }> => {
    const res = await apiService.post('inventory/order-stats-csv', { data, baseUrl });
    // eslint-disable-next-line
    return res.data;
  },

  getBrandAddons: async (brandId: string): Promise<{ status: string; message: string }> => {
    const data = await apiService.get(`brands/addons/${brandId}`, { baseUrl: brandMgtBaseUrl });
    // eslint-disable-next-line
    return data.data;
  }
};
